// extracted by mini-css-extract-plugin
module.exports = {"container":"PressPack-module--container--32d6s"};